<template>
  <div class="MobileNav">
    <MessengerNotificationsButton />
<!--     <ConnectionNotificationsButton /> -->
    <TasksButton />
    <CommunityLink />
  </div>
</template>

<script>
import MessengerNotificationsButton from "./Dropdowns/MessengerNotificationsButton";
/* import ConnectionNotificationsButton from "./Dropdowns/ConnectionNotificationsButton"; */
import TasksButton from "./Dropdowns/TasksButton.vue";
import CommunityLink from "./NavComponents/CommunityLink";

export default {
  components: {
    MessengerNotificationsButton,
/*     ConnectionNotificationsButton, */
    TasksButton,
    CommunityLink,
  },
};
</script>

<style>
.MobileNav {
  display: flex;
  flex-direction: row;
  box-shadow: 0 0 0 1px rgb(15 15 15 / 5%), 0 3px 6px rgb(15 15 15 / 10%), 0 9px 24px rgb(213 213 213 / 20%);
  background-color: rgb(255 255 255 / 100%) !important;
  height: 45px;
  align-items: center;
  justify-content: space-around;
  position: fixed;
  bottom: 0;
  width: 100%;
  z-index: 10001;
}
</style>
